
import { LitElement, html, css } from "https://cdn.skypack.dev/pin/lit@v3.1.0-tFevN6Jy6oXwAencZaJF/mode=imports,min/optimized/lit.js";
import { customElement, property, state } from "https://cdn.skypack.dev/pin/lit@v3.1.0-tFevN6Jy6oXwAencZaJF/mode=imports,min/optimized/lit/decorators.js";

// import { LitElement, html, css } from 'lit';
// import { customElement, property, state } from 'lit/decorators.js';
// import { TemplateResult } from 'lit/html.js';
// Turn off update warnings on all LitElements
LitElement.disableWarning?.('change-in-update');

/**
 * Defines the structure for a single chat message object.
 */
interface ChatMessage {
  author: string;
  text: string;
  timestamp: string;
  isSelf: boolean;
  attachments: any[];
  sender: {
    id: string;
    name: string;
    avatarUrl: string;
  };
  avatarUrl?: string; // Optional URL for the avatar image
}

declare global {
  interface Array<T> {
    toReversed(): T[];
  }
}

@customElement('live-chat-component')
export class LiveChatComponent extends LitElement {
  // --- State and Properties ---
  @property({ attribute: 'channelId' })
  channelId = '';

  @property({ attribute: 'iconBG' })
  iconbg = '';

  @property({ attribute: 'chatBG' })
  chatbg = '';

  @property({ attribute: 'messenger' })
  messenger = '';

  @property({ attribute: 'zalo' })
  zalo = '';

  agentName = 'Trần Văn A'; // Default agent name

  @state()
  messages: ChatMessage[] = [];

  @state()
  currentMessage = '';

  // NEW STATE: Controls whether the pre-chat form is displayed
  @state()
  private showPreChatForm = true;

  // EXISTING STATE: Controls whether the main chat window is displayed
  @state()
  private isMinimized = true;

  // NEW STATE: Form inputs
  @state()
  private fullName = '';

  @state()
  private email = '';

  @state()
  private phoneNumber = '';
  private socket: WebSocket | null = null;
  private token = '';
  private roomId = '';
  private memberId = '';
  private messagePaging: any = null;
  private hasMoreMessages = true;
  private loadingMoreMessages = false;
  private hasUnreadMessage = false;
  private originalTitle: string = document.title;
  private _titleInterval: any = null;
  private audioElement = new Audio('https://teamy.vn/beep.mp3');
  private isConnecting = true;
  private filesPasted: any[] = [];
  private filesUploaded: any[] = [];

  // --- Styling ---
  static override styles = css`
        :host {
            position: fixed;
            bottom: 10px;
            right: 25px;
            z-index: 1000;
            display: block; 
            font-family: system-ui, sans-serif;
            font-weight: 400;
            line-height: normal;
        }
        
        /* 1. Base Container Styles (Used for both Form and Chat) */
        .chat-container {
            display: flex;
            flex-direction: column;
            width: 360px;
            border: 1px solid #eee;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            overflow: hidden;
            background: white;
        }
        /* Make chat-window height explicit, pre-chat form height is determined by content */
        .chat-window {
            height: 660px;
            transition: height 0.3s ease-in-out;
        }

        /* 2. Pre-Chat Form Styles (NEW) */
        .pre-chat-form {
            padding: 20px;
            /* Height is determined by content */
        }
        .form-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .form-header h2 {
            font-size: 20px;
            margin: 0;
            color: #3a3a3a;
        }
        .form-header .icon-btn {
            color: #3a3a3a;
        }
        .form-description {
              font-size: 14px;
              color: #3a3a3a;
              margin-bottom: 20px;
              margin-top: 6px;
        }
        .form-group {
            margin-bottom: 15px;
        }
        .form-group label {
                display: block;
    font-size: 14px;
    color: #3a3a3a;
    margin-bottom: 8px;
        }
        .form-group input {
           width: 100%;
    padding: 9px;
    border: 1px solid #bcbcbc;
    border-radius: 5px;
    box-sizing: border-box;
    font-size: 14px;
        }
        .form-actions {
            display: flex;
            justify-content: flex-end;
                margin-top: 35px;
        }
        .btn {
               padding: 9px 25px;
    border-radius: 5px;
            cursor: pointer;
            font-weight: 600;
            margin-left: 10px;
            transition: background-color 0.2s ease;
        }
        .btn-primary {
            background-color: #007bff;
            color: white;
            border: none;
        }
        .btn-primary:hover:not(:disabled) {
            background-color: #0056b3;
        }
        .btn-secondary {
            background-color: #f0f0f0;
            color: #3a3a3a;
            border: 1px solid #ddd;
        }
        .btn-secondary:hover {
            background-color: #e0e0e0;
        }
        .btn:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }

        /* 3. Minimize/Maximize Button Styles (Unchanged) */
        .chat-toggle-button {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            color: white;
            border: none;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.5em;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
            transition: background-color 0.2s ease;
            transform: translate(-10px, -10px);
            background: #007bff;

            img{
              border-radius: 50%;
              width: 50px;
              height: 50px;
            }
        }
       
        /* 4. Header Styles (Mostly Unchanged) */
        .header { 
            background-color: #fff; color: #3a3a3a; padding: 10px; display: flex; justify-content: space-between; 
            align-items: center; border-bottom: 1px solid #bcbcbc;
        }
        .header-content { display: flex; align-items: center; flex: 1; }
        .header-avatar { width: 48px; height: 48px;     margin-right: 10px;}

        .header-avatar img { width: 100%; height: 100%; object-fit: cover; }
        .header-details { display: flex; flex-direction: column; line-height: 1.4; }
        .header-title { 
          font-size: 16px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.31;
          letter-spacing: -0.32px;
          text-align: left;
          color: #3a3a3a; }
        .header-subtitle { font-size: 14px; color: #9a9a9a; }
        .header-actions { display: flex; align-items: center; }
        .icon-btn { background: none; border: none; color: #3a3a3a; font-size: 1.5em; cursor: pointer; padding: 5px; margin-left: 5px; transition: color 0.2s ease; }
        .icon-btn:hover { color: #3a3a3a; }

        /* 5. Message/Avatar/Footer Styles (Mostly Unchanged) */
        .messages { position: relative;flex: 1; padding: 10px; overflow-y: auto; display: flex; flex-direction: column-reverse;padding-top: 30px;}
        .message-container { display: flex; margin-bottom: 6px; align-items: flex-end; flex-wrap: wrap;  }
        .message-container.other { justify-content: flex-start; }
        .message-container.other .avatar { margin-right: 6px; }
        .message-container.other .message-bubble { background-color: #e9e9eb; color: #3a3a3a; border-bottom-left-radius: 3px; }
        .message-container.self { justify-content: flex-end; 
          .attachments {
            margin-top: 8px;
            text-align: right;
            align-items: flex-end;
            max-width: 100%;
          }
        }
        .message-container.self .message-bubble { background-color: #007bff; color: white; border-bottom-right-radius: 3px; }
        .avatar { width: 38px; height: 38px; border-radius: 50%; object-fit: cover; flex-shrink: 0; }
        .message-bubble {font-weight: 400;max-width: 75%; padding: 8px 12px; border-radius: 18px; line-height: 1.4; word-wrap: break-word;     font-size: 16px;;position: relative; }
    
        @keyframes blink {
            0% { opacity: 1; }
            50% { opacity: 0.5; }
            100% { opacity: 1; }
        }
        .loading-more-messages {
          opacity: 1;
          visibility: visible;
          position: absolute;
    left: 8px;
    top: 30px;
          font-size: 50px;
          height: 15px;
        }
        .blinking {
            animation: blink 1s infinite;
        }
        .hidden {
          opacity: 0;
          visibility: hidden;
          height: 0;
        }


        /* Message border radius styling */
        .admin-message {
            .message-bubble {
                border-radius: 18px;
            }
        }
          
        .user-message {
            .message-bubble {
                border-radius: 18px;
            }
        }
          
          /* Single message in a sequence */
        .single-message {
            .message-bubble {
                border-radius: 18px;
            }
        }
          
          /* First message in a sequence */
        .admin-message.first-in-sequence {
            margin-bottom: 6px !important;
            .message-bubble {
                border-radius: 18px 18px 4px 18px;
            }
        }
          
        .user-message.first-in-sequence {
            margin-bottom: 6px !important;
             .avatar {
            display: none;
          }
            .avatar-placeholder{
            width: 44px;
            }
            .message-bubble {
                border-radius: 18px 18px 18px 4px;
            }
        }
          
          /* Middle message in a sequence */
        .admin-message.middle-in-sequence {
            margin-bottom: 6px !important;
            .message-bubble {
                border-radius: 18px 4px 4px 18px;
            }
        }
          
        .user-message.middle-in-sequence {
            margin-bottom: 6px !important;
             .avatar {
            display: none;
          }
            .avatar-placeholder{
              width: 44px;
            }
            .message-bubble {
                border-radius: 4px 18px 18px 4px;
            }
        }
          
          /* Last message in a sequence */
        .admin-message.last-in-sequence {
            .message-bubble {
                border-radius: 18px 4px 18px 18px;
            }
        }
          
        .user-message.last-in-sequence {
            .message-bubble {
                border-radius: 4px 18px 18px 18px;
            }
        }
     
        .footer { padding: 10px; align-items: center; }
        .input-area { flex: 1; display: flex; align-items: center;  border-radius: 8px;
          border: solid 1px #bcbcbc;  padding: 8px 10px; background-color: white; }
        .input-area textarea { height: 60px;width: 100%;
          border: none;
          outline: none;
          resize: none;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.2;
          letter-spacing: -0.5px;
          text-align: left;
          color: #3a3a3a;
        }
        .input-area.disabled  {
          background-color: #f0f0f0;
          cursor: not-allowed;
          pointer-events: none;
          textarea {
            background-color: #f0f0f0;
          }
        }
        .icon-button { background: none; border: none; color: #3a3a3a;     margin-top: 38px;
          font-size: 1.2em; cursor: pointer; padding: 0 5px; transition: color 0.2s ease; margin-left: 5px; }
        .footer > button { background-color: #007bff; color: white; border: none; padding: 10px 15px; border-radius: 4px; cursor: pointer; transition: background-color 0.3s; font-size: 1em; flex-shrink: 0; }
        .footer > button:hover:not(:disabled) { background-color: #0056b3; }
        .footer > button:disabled { background-color: #a0cffc; cursor: not-allowed; }

       .attachments{
        max-width: calc(100% - 45px);
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
        width: 100%;
        .attachment{
              border-radius: 4px;
              padding: 4px;
              padding-bottom: 0;
              width: 81%;
              &:hover{
                background-color: #E7E7E7FF;
              }
        }
       }
       .files-pasted{
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        width: 97%;
        .image-pasted{
          display: flex;
          font-size: 14px;
          box-shadow: 0 0 1px 0 #929292FF;
          border-radius: 4px;
          margin-bottom: 5px;
          padding: 0 4px;
          width: 100%;
          img{
            width: 55px;
            height: 50px;
            object-fit: contain;
            margin-right: 8px;
            border-radius: 4px;
          }
          button{
            background: none;
            border: none;
            color: #3a3a3a;
            font-size: 20px;
            cursor: pointer;
            padding: 0 8px;
            transition: color 0.2s ease;
          }
          p{
            margin: 0;
          }
          .image-pasted-name{
            margin-top: 7px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            width: calc(100% - 91px);
          }
          .image-pasted-name-text{
            width: 93%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: block;
          }
          .image-pasted-size{
            margin: 0;
            color: #848484;
            font-size: 12px;
          }
        }
       }

        @media (max-width: 768px) {
          :host {
                      width: 100%;
            bottom: 0;
            height: 100dvh;
            right: 0;
            left: 0;
            top: 0;
            }
              .chat-container.pre-chat-form {
                            width: calc(100% - 40px);
            margin-left: 0;
            height: 100%;
            padding-top: 30%;
              }
                  .chat-container.chat-window {
                          height: 100dvh;
            width: 100%;
            margin-left: 0;
                  }
              .chat-toggle-button {
                        position: absolute;
            transform: unset;
            bottom: 16px;
            right: 15px;
              }
        }
  `;

  // --- Lifecycle Methods ---
  override firstUpdated(): void {
    // Watch for Document Visibility change
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.socket?.close();
        this.socket = null;
        this._setupMockConnection();
      }
    });
    console.log(this.iconbg); console.log(this.chatbg);

    if (localStorage.getItem('teamy_lc_channelId') && localStorage.getItem('teamy_lc_channelId') == this.channelId) {
      this.fullName = localStorage.getItem('teamy_lc_fullName') || '';
      this.email = localStorage.getItem('teamy_lc_email') || '';
      this.phoneNumber = localStorage.getItem('teamy_lc_phoneNumber') || '';
      this.token = localStorage.getItem('teamy_lc_token') || '';
      this.roomId = localStorage.getItem('teamy_lc_roomId') || '';
      this.memberId = localStorage.getItem('teamy_lc_memberId') || '';
      this.showPreChatForm = false;
      return
    }else{
      localStorage.removeItem('teamy_lc_token');
      localStorage.removeItem('teamy_lc_roomId');
      localStorage.removeItem('teamy_lc_channelId');
      localStorage.removeItem('teamy_lc_fullName');
      localStorage.removeItem('teamy_lc_email');
      localStorage.removeItem('teamy_lc_phoneNumber');
      localStorage.removeItem('teamy_lc_memberId');
    }

    this.showPreChatForm = true;
  }

  override connectedCallback(): void {
    super.connectedCallback();
    // Socket connection should ideally happen AFTER pre-chat form submission
    // this._setupMockConnection();
  }

  // --- Template Rendering ---

  protected override render(): TemplateResult {

    if (this.isMinimized) {
      return this._renderMinimizeButton();
    }

    // If maximized, check if the pre-chat form needs to be shown
    if (this.showPreChatForm) {
      return this._renderPreChatForm();
    }

    // If maximized and form is submitted, show the main chat window
    return this._renderChatWindow();
  }

  private _renderMinimizeButton(): TemplateResult {
    return html`
           ${this.zalo?.length>10 ? html`<a class="chat-toggle-button" target="_blank" href="${this.zalo}" style="margin-bottom:15px;${this.iconbg ? `background:${this.iconbg}`: ''}">
                      <img src="https://teamy.vn/zalo-chat-icon.png" alt="Chat" />
            </a>` : ''}

            ${this.messenger?.length>10 ? html`<a class="chat-toggle-button" target="_blank" href="${this.messenger}" style="margin-bottom:15px;${this.iconbg ? `background:${this.iconbg}`: ''}">
                      <img src="https://teamy.vn/fb-chat-icon.png" alt="Chat" />
            </a>` : ''}             

            <button class="chat-toggle-button" @click=${this.maximizeChat} style="${this.iconbg ? `background:${this.iconbg}`: ''}">
                <img src="https://teamy.vn/bubble-chat-icon.png" alt="Chat" />
                   ${this.hasUnreadMessage ? html`<span style="position:absolute; top:-2px; right:2px; width:10px; height:10px; border-radius:50%; background:red;"></span>` : ''}
            </button>
        `;
  }

  private _renderPreChatForm(): TemplateResult {
    const isStartButtonDisabled = !this.fullName || !this.email; // Require Name and Email
    return html`
            <div class="chat-container pre-chat-form">
                <div class="form-header">
                    <h2>Bắt đầu cuộc trò chuyện</h2>
                    <button class="icon-btn" @click=${this.minimizeChat}>
                        &times; 
                    </button>
                </div>
                <p class="form-description">Vui lòng cung cấp thông tin của bạn để bắt đầu cuộc trò chuyện</p>

                <form @submit=${this._handleFormSubmit}>
                    <div class="form-group">
                        <label for="fullName">Họ tên</label>
                        <input 
                            id="fullName" 
                            type="text" 
                            .value=${this.fullName} 
                            @input=${(e: Event) => this.fullName = (e.target as HTMLInputElement).value}
                            required 
                        />
                    </div>
                    <div class="form-group">
                        <label for="email">Email</label>
                        <input 
                            id="email" 
                            type="email" 
                            .value=${this.email} 
                            @input=${(e: Event) => this.email = (e.target as HTMLInputElement).value}
                            required 
                        />
                    </div>
                    <div class="form-group">
                        <label for="phone">Số điện thoại</label>
                        <input 
                            id="phone" 
                            type="tel" 
                            .value=${this.phoneNumber} 
                            @input=${(e: Event) => this.phoneNumber = (e.target as HTMLInputElement).value}
                        />
                    </div>
                    <div class="form-actions">
                        <button type="button" class="btn btn-secondary" @click=${this.minimizeChat}>Hủy</button>
                        <button type="submit" class="btn btn-primary" ?disabled=${isStartButtonDisabled}>Bắt đầu</button>
                    </div>
                </form>
            </div>
        `;
  }

  private _renderChatWindow(): TemplateResult {
    return html`
            <div class="chat-container chat-window">
                <div class="header">
                    <div class="header-content">
                        <div class="header-avatar">
                        <img src="https://teamy.vn/icons/ai-logo.png" alt="User" />
                        </div> 
                        <div class="header-details">
                            <span class="header-title">Chăm sóc khách hàng</span>
                            <span class="header-subtitle">Nhân viên: ${this.agentName}</span>
                        </div>
                    </div>
                    <div class="header-actions">
                        <button class="icon-btn" @click=${this._handleMoreOptions}>
                            &#x22EF; 
                        </button>
                        <button class="icon-btn" @click=${this.minimizeChat}>
                            &times; 
                        </button>
                    </div>
                    <div class="loading-more-messages blinking ${!this.loadingMoreMessages ? 'hidden' : ''}">...</div>

                </div>
                
              <div class="messages" @scroll=${this._handleMessageScroll}>
                    ${this.messages?.map((msg, index) => this._renderMessage(msg, index))}
              </div>

                <div class="footer">
                   <div class="files-pasted">
                    ${this.filesPasted?.map((img, index) => this._renderImageMessage(img))}
                   </div>

                    <div class="input-area ${this.isConnecting ? 'disabled' : ''}" >
                        <textarea
                        id="t-message"
                            .value=${this.currentMessage}
                            @paste=${this._handlePaste}
                            @input=${this._handleInputChange}
                            @keydown=${this._handleKeyPress}
                            @click=${this._clearNotification}
                            placeholder="${this.isConnecting ? 'Đang kết nối...' : 'Nhập tin nhắn và gõ enter'}"
                        ></textarea>
                    
                        <button class="icon-button" title="Gửi tệp">
                        <label for="livechat-upload-chat" style="cursor: pointer;" title="Gửi tệp">
                          <img src="https://teamy.vn/icons/attachment.png" alt="Attachment" />
                        </label>
                            <input hidden type="file" id="livechat-upload-chat" @change=${(e: Event) => this.changeFile((e.target as HTMLInputElement).files || [])} multiple />
                        </button>
                    </div>
                </div>
            </div>
        `;
  }

  private _initFormSubmit(): void {
    this._openChat(false, false);
  }
  // --- Form Submission Logic (NEW) ---
  private _handleFormSubmit(e: Event): void {
    e.preventDefault();
    // Call API to create chat room with form data
    this._openChat(true, false);
  }

  private _openChat(isInit: boolean, showPreChatForm: boolean): void {
    this.messages = [];
    this.messagePaging = null;
    this.hasMoreMessages = true;
    this.loadingMoreMessages = false;
    fetch('https://apis.teamy.vn/v1/web/chat/room', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        channelId: this.channelId,
        email: this.email,
        phone: this.phoneNumber,
        fullName: this.fullName
      })
    })
      .then(async (res) => {
        if (!res.ok) {
          throw new Error('Không thể tạo phiên trò chuyện');
        }

        const data = await res.json();
        if (res.status != 200) {
          throw new Error(data.message);
        }
        // 1. Save the data to localStorage
        this.agentName = data.data?.channelId?.fullName;
        this.token = data.data.token;
        this.roomId = data.data.roomId;
        this.memberId = data.data.memberId?._id;
        localStorage.setItem('teamy_lc_token', this.token);
        localStorage.setItem('teamy_lc_roomId', this.roomId);
        localStorage.setItem('teamy_lc_channelId', this.channelId);
        localStorage.setItem('teamy_lc_fullName', this.fullName);
        localStorage.setItem('teamy_lc_email', this.email);
        localStorage.setItem('teamy_lc_phoneNumber', this.phoneNumber);
        localStorage.setItem('teamy_lc_memberId', this.memberId);

        // 2. Hide the form and open the chat
        this.showPreChatForm = showPreChatForm;

        // 3. Set up connection (now that we have user info)
        this._setupMockConnection();

        // 4. Send initial greeting
        if (isInit) {
          this._addSystemMessage(`Xin chào ${this.fullName}! Bạn có thể trò chuyện với chúng tôi ngay bây giờ.`);
        }

        this._fetchMessages(this.roomId, true);


        // 5. Focus the chat input
        requestAnimationFrame(() => {
          const input = this.shadowRoot?.querySelector('.input-area textarea') as HTMLTextAreaElement;
          input?.focus();
        });

        console.log(`User started chat: ${this.fullName} (${this.email})`);
      })
      .catch((err) => {
        console.error('Lỗi khi tạo phòng chat:', err);
        this._addSystemMessage("Có lỗi khi khởi tạo trò chuyện. Vui lòng thử lại hoặc làm mới trang.");
      });
  }

  // --- Toggle Handlers ---
  private maximizeChat(): void {
    this.isMinimized = false;
    this._clearNotification();
    if (this.token && this.roomId && this.channelId) {
      this._initFormSubmit();
      return;
    }
  }

  private minimizeChat(): void {
    this.isMinimized = true;
    this._clearNotification();
  }


  override disconnectedCallback(): void {
    this._clearNotification();
    if (this.socket) {
      console.log('WebSocket closed (mocked).');
    }
    super.disconnectedCallback();
  }

  protected override updated(changedProperties: Map<string | number | symbol, unknown>): void {
    if (changedProperties.has('messages') && !this.isMinimized) {
      this._scrollToBottom();
    }
  }

  private _renderMessage(msg: ChatMessage, index: number): TemplateResult {
    const isSelf = msg.isSelf;
    const containerClass = isSelf ? 'message-container self' : 'message-container other';
    const classes = getMessageStyle(msg, this.messages, index, msg.sender.id == this.memberId);
    const defaultBotAvatar = 'https://teamy.vn/icons/ai-logo.png';
    const avatarSrc = msg.avatarUrl || defaultBotAvatar;

    return html`
            <div class=${containerClass + ' ' + classes} title="${msg.timestamp}">
                ${!isSelf
        ? html`<img class="avatar" src=${avatarSrc} alt="${msg.author} avatar" /><div class="avatar-placeholder"></div>`
        : ''
      }
        ${msg.text ? html`<div class=${'message-bubble ' + (isSelf ? 'self' : 'other')} style="${this.chatbg && isSelf ? `background:${this.chatbg}`: ''}">
              ${msg.text}
         </div>` : ''}

         ${msg.attachments?.length > 0 ? 
              html`<div class="attachments">${msg.attachments?.map((attachment: any) => 
              html`<div class="attachment" style="cursor: pointer;" @click=${() => this._downloadFile(attachment)}>
               ${attachment.mimetype.includes('image') ? html`<img src=${attachment.url} alt=${attachment.name} style="max-width: 100%; object-fit: contain;" />` :
                html`
                <div style="display: flex;
                            align-items: center;
                            box-shadow: 0 0 1px 0 #929292FF;
                            border-radius: 4px;
                            padding: 5px;">
                  <img src="https://teamy.vn/icons/attachment.png" style="width: 18px;
                                                                          height: fit-content;
                                                                          margin-right: 10px;" />
                  <div>
                    <p class="attachment-name" style="margin: 0;
                                                      font-size: 13px;
                                                      white-space: nowrap;
                                                      overflow: hidden;
                                                      text-overflow: ellipsis;
                                                      max-width: 200px;">${attachment.filename}</p>
                    <p class="attachment-size" style="font-size: 12px; text-align: left;
                                                      color: #a3a3a3;
                                                      margin: 0;">Tải về</p>
                  </div>
                </div>`}
             
              </div>`)}
              </div>` :
              
             ''
          }
             
        </div>`;
  }

  private _downloadFile(attachment: any): void {
    window.open(attachment.url, '_blank');
  }

  private _renderImageMessage(img: any): TemplateResult {
    return html`
      <div class="image-pasted">
        <img src=${img.type == 'image'? img.base64: 'https://teamy.vn/icons/attachment.png'} style="${img.type == 'file'?'object-fit: none': ''}" alt="Image" />
        <div class="image-pasted-name">
          <p class="image-pasted-name-text">${img.name}</p>
          <p class="image-pasted-size">${img.size ? formatFileSize(img.size) : ''} </p>
        </div>
        <button title="Xóa" @click=${() => this.removeFile(img)}>
          &times; 
        </button>
      </div>
    `;
  }
  
  private _handlePaste(e: Event): void {
   // e.preventDefault();
    const items = ( (e as ClipboardEvent).clipboardData || (e as any).originalEvent?.clipboardData)?.items;
      if (items && items.length) {
        for (const index in items) {
          const item = items[index];
          if (item.kind == "file" && item.type.includes("image")) {
            const file = item.getAsFile();

            const reader = new FileReader();
            reader.onload = (event) => {
              const imgInfo = new Image();
              const name = "pasted_" + new Date().getTime() + "." + file.type.split("/")[1];
              imgInfo.onload = () => {
                this.filesPasted.push({
                  file: file,
                  base64: (event.target as FileReader).result,
                  name: name,
                  type: "image",
                  size: file.size
                });
                this.requestUpdate();
                this._scrollToBottom();
              };
              imgInfo.src = (event.target as FileReader).result as string;
             
            };
            reader.readAsDataURL(file);

          }
        
        }
      }
    //e.preventDefault();
  }

  private _handleInputChange(e: Event): void {
    const input = e.target as HTMLTextAreaElement;
    this.currentMessage = input.value;
  }

  private _handleKeyPress(e: KeyboardEvent): void {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
    }
    if (e.key === 'Enter' && !e.shiftKey && (this.currentMessage.trim() || this.filesPasted.length > 0 )) {
      setTimeout(() => {
        this._sendMessage();
      }, 100);
    }
  }

  private _sendMessage = async (): Promise<void> => {
    const text = this.currentMessage.trim();
    if (!text && this.filesPasted.length == 0) return;

    try {
      // Use the stored token if available
      const message: any = {};
      const filesPasted = [...this.filesPasted];
      this.filesPasted = [];
      const recipientId = this.roomId;
      if (this.token && recipientId) {
        this.currentMessage = '';
        const newMessage: ChatMessage = {
          author: this.fullName,
          text: text,
          timestamp: formatTimestamp(new Date().toISOString()),
          isSelf: true,
          attachments: [],
          sender: {
            id: this.memberId,
            name: this.fullName,
            avatarUrl: 'https://teamy.vn/icons/ai-logo.png'
          }
        };

        this.messages = [newMessage, ...this.messages];
        if (text) {
          message.text = text;
        }

       if (filesPasted.length > 0) {
        await this._uploadFiles(filesPasted);
        
        if (this.filesUploaded.length > 0) {
          message.attachments = [...this.filesUploaded];
          newMessage.attachments = [...this.filesUploaded];
        }
        this.filesUploaded = [];
        this.requestUpdate();
       }
       
        fetch(`https://apis.teamy.vn/v1/web/chat/conversations/${recipientId}/messages?channelType=web&channelId=${this.channelId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.token}`,
          },
          body: JSON.stringify({
            recipientId: recipientId,
            message: message
          })
        }).then(async (res)=>{
          const data = await res.json();
          if (data.status != 200) {
            this.messages = this.messages.slice(1);
            this.requestUpdate();
          }
    
        }).catch(err => {
          // Remove the last message from the messages array
          this.messages = this.messages.slice(1);
          this.requestUpdate();
          // Only log, don't interrupt send
          console.error('Failed to send message to API:', err);
        });
      }
    } catch (err) {
      console.error('Error preparing API call:', err);
    }
  }

  private _uploadFiles = async (filesPasted: any[]): Promise<void> => {
    const files = filesPasted;
    if (!files || files.length == 0) return;
    for (const file of files) {
      const formData = new FormData();
      formData.append('file', file.file);
      const res = await fetch(`https://apis.teamy.vn/v1/web/chat/conversations/${this.roomId}/messages/attachments?channelId=${this.channelId}`, {
        method: 'POST',
        headers: {
          'authorization': `Bearer ${this.token}`
        },
        body: formData
      });
      if (!res.ok) {
        throw new Error("Không thể upload tệp đính kèm");
      }
      const data = await res.json();
      if (data.status != 200) {
        throw new Error(data.message);
      }else{
        this.filesUploaded.push(data.data);
      }
    }
  }

  private _addSystemMessage(text: string): void {
    const systemMessage: ChatMessage = {
      author: 'System',
      text: text,
      timestamp: formatTimestamp(new Date().toISOString()),
      isSelf: false,
      avatarUrl: 'https://teamy.vn/icons/ai-logo.png',
      sender: {
        id: 'system',
        name: 'System',
        avatarUrl: 'https://teamy.vn/icons/ai-logo.png'
      }
    };
    this.messages = [...this.messages, systemMessage];
  }

  private _handleMoreOptions(): void {
  }

  // --- Notification Logic (Simplified) ---
  private _startNotification(): void {
    if (!this.hasUnreadMessage) {
      this.hasUnreadMessage = true;
      // Add blinking animation for document title
      if (this._titleInterval) {
        clearInterval(this._titleInterval);
      }
      let showingNewMessage = true;
      this._titleInterval = setInterval(() => {
        document.title = showingNewMessage
          ? `(1) Tin nhắn mới! - ${this.originalTitle}`
          : this.originalTitle;
        showingNewMessage = !showingNewMessage;
      }, 800);
    }
  }

  private _clearNotification(): void {
    if (this.hasUnreadMessage) {
      this.hasUnreadMessage = false;
      document.title = this.originalTitle;
      if (this._titleInterval) {
        clearInterval(this._titleInterval);
      }
    }
  }

  private _scrollToBottom(): void {
    requestAnimationFrame(() => {
      const messagesContainer = this.shadowRoot?.querySelector('.messages');
      if (messagesContainer) {
        messagesContainer.scrollTop = messagesContainer.scrollHeight + 1000;
      }
    });
  }

  private _fetchMessages = async (conversationId: string, scrollToBottom = true,after?: string, ) => {
    if (after || !this.messagePaging) {
      this.loadingMoreMessages = true;
      const url = `https://apis.teamy.vn/v1/web/chat/conversations/${conversationId}/messages?channelType=web&channelId=${this.channelId}${after ? `&after=${after}&limit=10` : ''}`;
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${this.token}`
        }
      });
      if (!res.ok) {
        this.loadingMoreMessages = false;
        this.hasMoreMessages = false;
        throw new Error("Không thể GET tin nhắn");
      }
      const data = await res.json();

      this.messages = [
        ...this.messages,
        ...data.data.messages.map((message: any) => ({
          author: message.sender.name,
          text: message.message.text,
          timestamp: formatTimestamp(message.createdTime),
          isSelf: message.sender.id == this.memberId,
          attachments: message.message.attachments,
          avatarUrl: message.sender.avatarUrl,
          sender: message.sender
        })),
      ];

      this.messagePaging = data.data?.paging?.cursors ?? {};
      this.hasMoreMessages = !!this.messagePaging?.after && data.data?.messages?.length >= 10;
      this.loadingMoreMessages = false;
      if (scrollToBottom) {
        this._scrollToBottom();
      }
    }
  }

  private _setupMockConnection(): void {
    // check if the socket is already connected
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      return;
    }
    // We'll send the token and other params as query params for demo (production may use headers).
    const wsUrl = `wss://apis.teamy.vn/socket.io/?EIO=4&transport=websocket`;
    this.socket = new WebSocket(wsUrl);
    this.isConnecting = true;
    this.requestUpdate();

    this.socket.onopen = () => {
      setTimeout(() => {
        this.socket?.send('40' + JSON.stringify({
          authorization: `Bearer ${this.token}`,
          scope: "login",
          userType: "web"
        }));
        this.isConnecting = false;
        this.requestUpdate();
      }, 100);
    };

    this.socket.onmessage = (event: MessageEvent) => {
      try {

        if (event.data == '2') {
          this.socket?.send('3');
          return;
        }
        if (!event.data.startsWith('42')) {
          return;
        }
        const jsonString = event.data.substring(2)
        const data = JSON.parse(jsonString);
        const eventName = data[0]; // "receivemessage"
        const jsonData = data[1]; // The object you want

        if (eventName == 'receivemessage' && jsonData.roomId == this.roomId && jsonData.senderId != this.memberId) {
          // Check if tab is inactive and play notification sound only if so
          if ((typeof document !== 'undefined' && document.hidden) || this.isMinimized) {
            try {
              this.audioElement.play();
            } catch (e) {
              // fail silently
            }
          }

          const reply: ChatMessage = {
            author: this.agentName,
            text: jsonData.message?.text || '',
            attachments: jsonData.message?.attachments || [],
            timestamp: formatTimestamp(new Date().toISOString()),
            isSelf: false,
            avatarUrl: 'https://teamy.vn/icons/ai-logo.png',
            sender: {
              id: jsonData.senderId,
              name: this.agentName,
              avatarUrl: 'https://teamy.vn/icons/ai-logo.png'
            }
          };
          this.messages = [reply, ...this.messages];
          this._scrollToBottom();
          if (this.isMinimized || (typeof document !== 'undefined' && document.hidden)) {
            this._startNotification();
          }
        }

      } catch (e) {
        console.warn('WebSocket message parse error', e, event.data);
      }
    };

    this.socket.onerror = (event) => {
      console.error("WebSocket error", event);
    };

    this.socket.onclose = () => {
      console.warn("WebSocket connection closed");
    };

  }

  private _handleMessageScroll = (event: Event) => {
    const target = event.target as HTMLElement;
    const { scrollTop, scrollHeight, offsetHeight } = target;
    if (scrollHeight + scrollTop - offsetHeight <= 50 && !this.loadingMoreMessages && this.hasMoreMessages) {
      this._loadMoreMessages();
    }
  };

  private _loadMoreMessages = async () => {
    if (
      this.loadingMoreMessages || !this.hasMoreMessages
    )
      return;

    this.loadingMoreMessages = true;
    this.requestUpdate();
    if (this.messagePaging?.after) {
      const lastMessageElement =
        this.shadowRoot?.querySelector('.messages')?.lastElementChild as HTMLElement;
        const lastMessageOffsetTop = lastMessageElement?.offsetTop;
        
      await this._fetchMessages(this.roomId, false, this.messagePaging?.after);
      requestAnimationFrame(() => {
        if (this.shadowRoot?.querySelector('.messages')) {
           this.shadowRoot.querySelector('.messages')!.scrollTop = lastMessageOffsetTop-50;
        }
      });
      this.loadingMoreMessages = false;
    } else {
      this.loadingMoreMessages = false;
    }
  };

  private changeFile = (files: File[]) => {

    if (!files || files.length == 0) {
      return;
    }
   
    Array.from(files).forEach((file) => {
        if ( file && file.size > 1024 * 1024 * 30) {
          alert("Tệp đính kèm không được lớn hơn 30MB.");
          return;
        }
        // Check for file size or dangerous extensions
        const dangerousExtensions = ['exe', 'bat', 'cmd', 'com', 'js', 'vbs', 'scr', 'pif', 'jar', 'msi', 'vb', 'wsf', 'cpl'];
        const fileNameLower = file.name.toLowerCase();
        const extMatch = fileNameLower.match(/\.(\w+)$/);
        const ext = extMatch ? extMatch[1] : '';
        if (
          (ext && dangerousExtensions.includes(ext))
        ) {
          alert("Tệp đính kèm không được có phần mở rộng nguy hiểm.");
          return;
        }
        
        if (file.type.includes("image") ) {
          const reader = new FileReader();
          reader.onload = (event) => {
            const imgInfo = new Image();
            imgInfo.onload = () => {
              this.filesPasted.push({
                file: file,
                base64: (event.target as FileReader).result,
                name: file.name,
                type: "image",
                size: file.size
              });
              this.requestUpdate();
              this._scrollToBottom();
            };
            imgInfo.src = (event.target as FileReader).result as string;
           
          };
          reader.readAsDataURL(file);
          return;
        }else {
          this.filesPasted.push({
            file: file,
            base64: null,
            name: file.name,
            type: "file",
            size: file.size
          });
          this.requestUpdate();
        }
    });

    // To allow selecting the same file multiple times, reset the file input value.
    const fileInput = this.shadowRoot?.getElementById("livechat-upload-chat") as HTMLInputElement | null;
    if (fileInput) fileInput.value = "";
    
  };
  
  private removeFile = (file: any) => {
    this.filesPasted = this.filesPasted.filter(item => item.name !== file.name || item.size !== file.size);
    this.requestUpdate();
  };

}

const formatFileSize = (size: number) => {
  if (size < 1024) return size + ' B';
  if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB';
  return (size / (1024 * 1024)).toFixed(1) + ' MB';
};

const getMessageStyle = (
  currentMessage: ChatMessage,
  messages: ChatMessage[],
  index: number,
  isAdminMessage: boolean

) => {
  let classes = isAdminMessage ? 'admin-message' : 'user-message';
  const isLastInSequence =
    index === messages.length - 1 ||
    messages[index + 1].sender.id !== currentMessage.sender.id;
  const isFirstInSequence =
    index === 0 || messages[index - 1].sender.id !== currentMessage.sender.id;
  const isMiddleInSequence = !isFirstInSequence && !isLastInSequence;

  if (isFirstInSequence && isLastInSequence) {
    classes += ' single-message';
  } else if (isFirstInSequence) {
    classes += ' last-in-sequence';
  } else if (isLastInSequence) {
    classes += ' first-in-sequence';
  } else if (isMiddleInSequence) {
    classes += ' middle-in-sequence';
  }

  return classes;
};

const formatTimestamp = (timestamp: string) => {
  return new Date(timestamp).toLocaleString('vi-VN', { hour: '2-digit', minute: '2-digit' });
}

// =================================================================
// === AUTO-INITIALIZATION / DYNAMIC INJECTION LOGIC (UPDATED) ===
// =================================================================

/**
 * Finds the script tag that loaded this module by checking the source URL.
 * @param {string} componentTagName The name of the custom element tag ('live-chat-component').
 * @returns {HTMLScriptElement | null} The script tag element or null if not found.
 */
function findCurrentScriptTag(componentTagName: string): HTMLScriptElement | null {
  // 1. Get the likely source filename (e.g., 'LiveChatComponent.js' or 'LiveChatComponent.ts')
  // We assume the filename includes the tag name or a specific identifier.
  const scriptIdentifier = componentTagName.replace(/-/g, '').toLowerCase(); // 'livechatcomponent'

  // 2. Iterate through all script tags on the page
  const scripts = document.querySelectorAll('script');
  for (const script of scripts) {
    // 3. Check if the script's src or inner text contains the unique identifier
    // This is the most reliable method for dynamically loaded modules.
    if (script.src.toLowerCase().includes(scriptIdentifier) && script.type === 'module' && script.src.toLowerCase().includes('livechatcomponent')) {
      return script as HTMLScriptElement;
    }
  }
  // Fallback for scenarios where a bundler might alias the file heavily
  return document.currentScript as HTMLScriptElement | null;
}


function autoInitializeLiveChat(): void {
  const tagName = 'live-chat-component';

  if (!customElements.get(tagName)) {
    console.error('Live chat component class not yet defined.');
    return;
  }

  const scriptTag = findCurrentScriptTag(tagName);

  // Read config from the data attributes.
  // Use optional chaining (`?.`) for safety.
  const channelId = scriptTag?.dataset.channelid || 'Embedded Visitor';
  const chatbg = scriptTag?.dataset.chatbg || '';
  const iconbg = scriptTag?.dataset.iconbg || '';
  const messenger = scriptTag?.dataset.messenger || '';
  const zalo = scriptTag?.dataset.zalo || '';

  // 1. Create the custom element instance dynamically
  const chatElement = document.createElement(tagName);

  // 2. Set the properties via the attributes
  chatElement.setAttribute('channelId', channelId);
  (chatElement as any).channelId = channelId;
  chatElement.setAttribute('chatbg', chatbg);
  (chatElement as any).chatbg = chatbg;
  chatElement.setAttribute('iconbg', iconbg);
  (chatElement as any).iconbg = iconbg;
  chatElement.setAttribute('messenger', messenger);
  (chatElement as any).messenger = messenger;
  chatElement.setAttribute('zalo', zalo);
  (chatElement as any).zalo = zalo;

  // 3. Append the element to the document body
  document.body.appendChild(chatElement);

  console.log(`Live Chat Widget auto-initialized for channelId: ${channelId}`);
}

customElements.whenDefined('live-chat-component')
  .then(() => {
    requestAnimationFrame(autoInitializeLiveChat);
  })
  .catch(err => console.error("Error defining live-chat-component:", err));